import { get } from "@/utils/http"

export const flushFeToken = get(`/pageRead/flushFeToken`)

export const pageUser = get(`/pageRead/user`)

// 获取沟通配置, 是否通过iframe打开, 1 是 0 否
export const fetchImSetting = get('/pageRead/imSetting')
